<template>

  <div>
    <el-form :model="formData" label-width="200px" :rules="rules">
      <el-form-item label="设备类型：" prop="star">
        <el-select v-model="formData.type_id"  placeholder="设备类型" clearable style="width: 250px" disabled>
          <el-option v-for="dict in deviceTypeAll" :key="dict.value" :label="dict.label" :value="dict.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="巡检项目：">
        <spna >共 </spna>
        <spna style="color: #0486fe"> {{formData.patrol_project_num}}</spna>
        <span > 项</span>
      </el-form-item>
      <el-row class="box">
        <el-icon @click="addOneProjectDescribe()" color="#0486fe" size="25" style="cursor: pointer;position:absolute;margin-top: 3px;margin-left: -40px"><ElIconCirclePlusFilled /></el-icon>
        <el-col :span="4">序号</el-col>
        <el-col :span="20">巡检项目描述</el-col>
      </el-row>
        <el-row v-for="(item,index) in formData.patrolProjectDescribeList" :key="index" class="row" style="margin-left: 120px;width: 550px;margin-top: 10px">

          <el-col :span="4" style="text-align: center;">
            <spna>{{index+1}}</spna>
          </el-col>
          <el-col :span="20">
            <el-input v-model="item.patrol_project_describe"  placeholder="巡检项目描述"></el-input>
          </el-col>

          <div class="close" @click="removeOneProjectDescribe(item.nanoid)">
            <el-icon color="red" size="25"><ElIconRemove /></el-icon>
          </div>
        </el-row>
      <el-form-item></el-form-item>

      <el-form-item>
        <el-button type="success" @click="updateProjectConfig" :loading="loading">提交</el-button>
      </el-form-item>

    </el-form>

  </div>
</template>

<script>
import {nanoid} from 'nanoid'

export default {
  name: "EqProjectConfigZhiZaoEdit",
  inject:['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        type_id: '',
        patrol_project_num: 1,
        patrolProjectDescribeList: [],
      },
      deviceTypeAll: [],

      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {

  },
  methods:{
    addFiveProjectDescribe() {
      for (let i = 0; i < 1; i++) {
        this.formData.patrolProjectDescribeList.push({
          nanoid: nanoid(),
        })
      }
    },
    addOneProjectDescribe() {
      this.formData.patrolProjectDescribeList.push({
        nanoid: nanoid(),
      })
      this.formData.patrol_project_num = this.formData.patrolProjectDescribeList.length
    },
    removeOneProjectDescribe(nanoid) {
      let index = this.formData.patrolProjectDescribeList.findIndex(item => item.nanoid === nanoid);
      this.formData.patrolProjectDescribeList.splice(index, 1);
      this.formData.patrol_project_num = this.formData.patrolProjectDescribeList.length
    },
    async getDeviceTypeAll() {
      await this.$http('eqProjectConfigZhiZaoService.getDeviceTypeAll',{},false).then(data => {
        this.deviceTypeAll = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },

    getProjectConfigList() {
      this.$http('eqProjectConfigZhiZaoService.getProjectConfig',this.parentData).then(data => {
        this.formData = data
      }, errMsg => {
        return this.$message.error(errMsg);
      })
    },
    updateProjectConfig(){
      this.formData.id = this.parentData.id
      this.loading = true
       this.$http('eqProjectConfigZhiZaoService.updateProjectConfig', this.formData).then(data => {
         this.loading = false
        this.$fn.closeWindow();
        this.$fn.search();
        return this.$message.success('编辑成功!');
      }, errMsg => {
         this.loading = false
        return this.$message.error(errMsg);
      })
    }

  },created() {
    this.addFiveProjectDescribe()
    this.getDeviceTypeAll()
    this.getProjectConfigList()

  }
}
</script>

<style scoped>
.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 550px;
  color:black;
  margin-left: 120px

}
.close {
  position: absolute;
  top: 5px;
  margin-left: -40px;
  font-size: 18px;
  cursor: pointer;
}
</style>